import React, { useEffect, useMemo, useState } from "react";
import OverviewView from "./OverviewView";
import { BASE_URL } from "../../../config/api";
import axios from "axios";

const retailers = [
  {
    id: 1,
    name: "Shree Mobile Store",
    code: "RET-001",
    city: "Pune",
    state: "Maharashtra",
    gstin: "27ABCDE1234Z5Z6",
    mobile: "+91 98765 11111",
    assignedAgent: "Rahul Patil",
    status: "Active", // Active | Deactivated
    connectionStatus: "Connected", // Connected | Not Connected
    usingProduct: true,
    totalSales: 480000,
    totalWarrantySold: 56,
    activeWarranties: 48,
    deactiveWarranties: 8,
    pendingTasks: 2,
    activationsThisMonth: 8,
  },
  {
    id: 2,
    name: "A1 Electronics",
    code: "RET-002",
    city: "Mumbai",
    state: "Maharashtra",
    gstin: "27PQRSX5678L9A1",
    mobile: "+91 99887 22222",
    assignedAgent: "Priya Singh",
    status: "Active",
    connectionStatus: "Not Connected",
    usingProduct: false,
    totalSales: 120000,
    totalWarrantySold: 15,
    activeWarranties: 13,
    deactiveWarranties: 2,
    pendingTasks: 1,
    activationsThisMonth: 3,
  },
  {
    id: 3,
    name: "Digital Zone",
    code: "RET-003",
    city: "Nashik",
    state: "Maharashtra",
    gstin: "27LMNOP9999C3F2",
    mobile: "+91 91234 55555",
    assignedAgent: "Rahul Patil",
    status: "Deactivated",
    connectionStatus: "Connected",
    usingProduct: false,
    totalSales: 80000,
    totalWarrantySold: 9,
    activeWarranties: 3,
    deactiveWarranties: 6,
    pendingTasks: 0,
    activationsThisMonth: 0,
  },
];

const agents = [
  {
    id: 1,
    name: "Rahul Patil",
    code: "AGT-001",
    region: "Pune & Nashik",
    onboardedRetailers: 18,
    activeRetailers: 14,
    totalCommission: 86500,
    pendingCommission: 12500,
    targetRetailers: 20,
    targetWarranties: 80,
  },
  {
    id: 2,
    name: "Priya Singh",
    code: "AGT-002",
    region: "Mumbai",
    onboardedRetailers: 10,
    activeRetailers: 9,
    totalCommission: 64200,
    pendingCommission: 8200,
    targetRetailers: 15,
    targetWarranties: 60,
  },
];

const warranties = [
  {
    id: "WAR-1001",
    retailer: "Shree Mobile Store",
    retailerCode: "RET-001",
    customer: "Amit Kulkarni",
    deviceType: "Mobile Phone",
    brand: "Samsung",
    model: "A55",
    imei: "356789012345678",
    type: "Sold", // Sold | Claim
    status: "Active", // Active | Expired | Cancelled
    soldOn: "2025-08-15",
    expiry: "2026-08-14",
    plan: "1 Year Extended Warranty",
    price: 18999,
  },
  {
    id: "WAR-1002",
    retailer: "A1 Electronics",
    retailerCode: "RET-002",
    customer: "Riya Shah",
    deviceType: "Tablet",
    brand: "Samsung",
    model: "Tab S9",
    imei: "351234567890123",
    type: "Sold",
    status: "Active",
    soldOn: "2025-10-20",
    expiry: "2026-10-19",
    plan: "6 Months Protection",
    price: 34999,
  },
  {
    id: "WAR-0998",
    retailer: "Digital Zone",
    retailerCode: "RET-003",
    customer: "Demo Customer",
    deviceType: "Mobile Phone",
    brand: "GoElectronix",
    model: "mPOS Demo",
    imei: "352345678901234",
    type: "Sold",
    status: "Expired",
    soldOn: "2024-01-10",
    expiry: "2025-01-09",
    plan: "1 Year Warranty",
    price: 12999,
  },
];

const claims = [
  {
    id: "CLM-5001",
    warrantyId: "WAR-1001",
    retailer: "Shree Mobile Store",
    customer: "Amit Kulkarni",
    device: "Samsung A55",
    raisedBy: "Retailer", // Retailer | Customer
    issue: "Device not powering on",
    status: "Pending", // Pending | Approved | Rejected | In Progress | Settled
    reason: "",
    approvedAmount: 3500,
    payableAmount: 3000,
    payableStatus: "Pending",
    paymentLink: "",
    lastUpdated: "2025-10-15",
  },
  {
    id: "CLM-5002",
    warrantyId: "WAR-0998",
    retailer: "Digital Zone",
    customer: "Demo Customer",
    device: "mPOS Demo",
    raisedBy: "Customer",
    issue: "Screen flickering",
    status: "Rejected",
    reason: "Warranty expired",
    approvedAmount: 0,
    payableAmount: 0,
    payableStatus: "Not Applicable",
    paymentLink: "",
    lastUpdated: "2025-01-07",
  },
  {
    id: "CLM-5003",
    warrantyId: "WAR-1002",
    retailer: "A1 Electronics",
    customer: "Riya Shah",
    device: "Samsung Tab S9",
    raisedBy: "Customer",
    issue: "No sound from speakers",
    status: "Approved",
    reason: "",
    approvedAmount: 2200,
    payableAmount: 2000,
    payableStatus: "Paid",
    paymentLink: "https://pay.goex.example/CLM-5003",
    lastUpdated: "2025-11-10",
  },
];

const commissionPayouts = [
  {
    id: "PAY-9001",
    forType: "Agent",
    entityName: "Rahul Patil",
    period: "Week 42 · 2025",
    role: "Onboarding Commission",
    commissionAmount: 22000,
    payableAmount: 20000,
    transferred: true,
    bankName: "HDFC Bank",
    accountLast4: "1234",
    txnId: "TXN-HDFC-2025-001",
    date: "2025-10-25",
  },
  {
    id: "PAY-9002",
    forType: "Retailer",
    entityName: "Shree Mobile Store",
    period: "Week 42 · 2025",
    role: "Warranty Sales Payout",
    commissionAmount: 12000,
    payableAmount: 12000,
    transferred: false,
    bankName: "ICICI Bank",
    accountLast4: "5678",
    txnId: "-",
    date: "2025-10-27",
  },
  {
    id: "PAY-9003",
    forType: "Agent",
    entityName: "Priya Singh",
    period: "Week 41 · 2025",
    role: "Onboarding Commission",
    commissionAmount: 15000,
    payableAmount: 15000,
    transferred: true,
    bankName: "SBI",
    accountLast4: "9999",
    txnId: "TXN-SBI-2025-221",
    date: "2025-10-20",
  },
];

const tasks = [
  {
    id: "TSK-101",
    retailer: "Shree Mobile Store",
    subject: "Train staff on warranty app",
    owner: "Ops Team",
    assignedTo: "Rahul Patil",
    dueDate: "2025-11-20",
    followUpDate: "2025-11-19",
    priority: "High",
    status: "In Progress",
    remark: "Training scheduled for Friday",
  },
  {
    id: "TSK-102",
    retailer: "A1 Electronics",
    subject: "Collect missing documents",
    owner: "Agent",
    assignedTo: "Priya Singh",
    dueDate: "2025-11-18",
    followUpDate: "2025-11-17",
    priority: "Medium",
    status: "Open",
    remark: "Awaiting Aadhaar from owner",
  },
  {
    id: "TSK-103",
    retailer: "Digital Zone",
    subject: "Follow-up for reactivation",
    owner: "Ops Team",
    assignedTo: "Rahul Patil",
    dueDate: "2025-11-25",
    followUpDate: "2025-11-23",
    priority: "Low",
    status: "Open",
    remark: "Call planned after Diwali offer",
  },
];

const legalRecords = [
  {
    id: 1,
    entityType: "Retailer",
    entityName: "Shree Mobile Store",
    aadhaar: "Verified via DigiLocker",
    pan: "Verified",
    agreementStatus: "Signed",
    privacyAccepted: true,
    paymentTerms: "Monthly, 15 days credit",
    lastUpdated: "2025-09-01",
  },
  {
    id: 2,
    entityType: "Retailer",
    entityName: "A1 Electronics",
    aadhaar: "Pending",
    pan: "Verified",
    agreementStatus: "Partially Signed",
    privacyAccepted: false,
    paymentTerms: "Weekly, advance",
    lastUpdated: "2025-10-10",
  },
];

const retailerUsers = [
  {
    id: 1,
    retailerName: "Shree Mobile Store",
    userName: "store.owner@shreemobile.in",
    role: "Admin",
    status: "Active",
    lastLogin: "2025-11-14 11:20",
  },
  {
    id: 2,
    retailerName: "Shree Mobile Store",
    userName: "cashier1@shreemobile.in",
    role: "Cashier",
    status: "Active",
    lastLogin: "2025-11-15 09:05",
  },
  {
    id: 3,
    retailerName: "A1 Electronics",
    userName: "owner@a1electronics.com",
    role: "Admin",
    status: "Inactive",
    lastLogin: "2025-10-30 18:40",
  },
];

function AdminSuperPortal() {
  const [view, setView] = useState("overview");

  // Local state so admin can approve / reject / toggle etc.
  const [apiStats, setApiStats] = useState({
  agentCount: 0,
  retailerCount: 0,
  connectedRetailers: 0,
  activeWarranties: 0,
  openClaims: 0,
  brandCount: 0,
  categoryCount: 0,
  productCount: 0,
  priceTemplates: 0,

  // Admin-only fallbacks (so OverviewView never breaks)
  totalRetailers: 0,
  activeRetailers: 0,
  totalWarranties: 0,
  settledClaims: 0,
  totalCommission: 0,
  pendingCommission: 0,
});

  const [loadingStats, setLoadingStats] = useState(false);
  const [retailerList, setRetailerList] = useState(retailers);
  const [agentList] = useState(agents);
  const [warrantyList] = useState(warranties);
  const [claimList, setClaimList] = useState(claims);
  const [payoutList, setPayoutList] = useState(commissionPayouts);
  const [taskList, setTaskList] = useState(tasks);
  const [legalList] = useState(legalRecords);
  const [retailerUserList, setRetailerUserList] = useState(retailerUsers);

  const authUser = JSON.parse(localStorage.getItem("authUserData"));
  const role = Number(authUser?.role);
  const companyId = authUser?.id;

  useEffect(() => {
  if (role !== 2 || !companyId) return;

  const fetchCompanyDashboard = async () => {
  try {

    setLoadingStats(true);

    const response = await axios.get(
      `${BASE_URL}warranty/warranty-dashboard`,
      {
        params: {
          company_id: companyId,
        },

        headers: {
          Accept:
            "application/json",

          "Content-Type":
            "application/json",
        },
      }
    );

    const res = response.data;

    if (res?.status) {

      const d = res.data;

      setApiStats({
        brandCount:
          d.brand_count,

        categoryCount:
          d.category_count,

        productCount:
          d.product_count,

        companyCount:
          d.company_count,

        agentCount:
          d.agent_count,

        retailerCount:
          d.retailer_count,

        activeRetailers:
          d.active_retailers_count,

        connectedRetailers:
          d.connected_retailers_count,

        openClaims:
          d.open_claims_count,

        activeWarranties:
          d.active_warranties_count,

        total_warranties_count:
          d.total_warranties_count,

        priceTemplates:
          d.price_templates_count,

        CompanyEmployee:
          d.company_employee_count,

        approved_commission:
          d.approved_commission,

        pending_commission:
          d.pending_commission,
      });
    }

  } catch (err) {

    console.error(err);

  } finally {

    setLoadingStats(false);

  }
};

  fetchCompanyDashboard();
}, [role, companyId]);


  

  const stats = useMemo(() => {
    const totalRetailers = retailerList.length;
    const activeRetailers = retailerList.filter((r) => r.status === "Active").length;
    const connectedRetailers = retailerList.filter(
      (r) => r.connectionStatus === "Connected"
    ).length;

    const totalAgents = agentList.length;

    const totalWarranties = warrantyList.length;
    const activeWarranties = warrantyList.filter((w) => w.status === "Active").length;

    const openClaims = claimList.filter(
      (c) => c.status === "Pending" || c.status === "In Progress" || c.status === "Approved"
    ).length;
    const settledClaims = claimList.filter((c) => c.status === "Settled").length;

    const totalCommission = payoutList.reduce(
      (sum, row) => sum + (row.commissionAmount || 0),
      0
    );
    const pendingCommission = payoutList
      .filter((row) => !row.transferred)
      .reduce((sum, row) => sum + (row.payableAmount || 0), 0);

    const totalRetailerUsers = retailerUserList.length;
    const activeRetailerUsers = retailerUserList.filter((u) => u.status === "Active").length;

    return {
      totalRetailers,
      activeRetailers,
      connectedRetailers,
      totalAgents,
      totalWarranties,
      activeWarranties,
      openClaims,
      settledClaims,
      totalCommission,
      pendingCommission,
      totalRetailerUsers,
      activeRetailerUsers,
    };
  }, [retailerList, agentList, warrantyList, claimList, payoutList, retailerUserList]);

  // Admin actions – claims
  

  // Admin actions – commission
  

  // Admin actions – users & retailers
  const handleToggleUserStatus = (id) => {
    setRetailerUserList((prev) =>
      prev.map((u) =>
        u.id === id
          ? {
              ...u,
              status: u.status === "Active" ? "Inactive" : "Active",
            }
          : u
      )
    );
  };

  const handleToggleRetailerStatus = (id) => {
    setRetailerList((prev) =>
      prev.map((r) =>
        r.id === id
          ? {
              ...r,
              status: r.status === "Active" ? "Deactivated" : "Active",
            }
          : r
      )
    );
  };

  // Admin actions – tasks
  const handleAddTask = (task) => {
    setTaskList((prev) => {
      const nextIndex = prev.length + 101;
      return [
        ...prev,
        {
          ...task,
          id: task.id || `TSK-${nextIndex}`,
        },
      ];
    });
  };

  const handleUpdateTask = (id, updates) => {
    setTaskList((prev) => prev.map((t) => (t.id === id ? { ...t, ...updates } : t)));
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-100 via-blue-50 to-slate-100 flex flex-col text-slate-900">

      <main className="flex-1 px-4 md:px-6 py-4">
       {view === "overview" && (
          <OverviewView
            stats={role === 2 ? apiStats : stats}
            loading={role === 2 ? loadingStats : false}
          />
        )}

      </main>
    </div>
  );
}


export default AdminSuperPortal;


